import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentSummaryContent$key } from "~/queries/__generated__/contentSummaryContent.graphql";

import { ContentSummaryContainer } from "./styles";

export type Props = {
  reference: contentSummaryContent$key;
};

export const ContentSummary: FunctionComponent<Props> = ({
  reference: reference_,
  ...attributes
}) => {
  const content = useFragment(
    graphql`
      fragment contentSummaryContent on Content {
        summary {
          text
        }
        ...contentSchemaRenderContent
      }
    `,
    reference_,
  );

  if (!content.summary?.text?.trim()) return null;

  return (
    <ContentSummaryContainer {...attributes}>{content.summary?.text ?? ""}</ContentSummaryContainer>
  );
};

ContentSummary.displayName = "ContentSummary";
